import NewStaff from "../../Components/NewStaff";
import React from "react";

const NewStaffView = () => {
    return <NewStaff />;
};

export default NewStaffView;
